// useEscapeKey — wires a window-level keydown listener that fires the supplied
// callback when the Escape key is pressed. No-op when `active` is false, so
// modals can safely use this without leaking listeners to non-rendered states.

import { useEffect } from 'react';

export function useEscapeKey(
  handler: () => void,
  options: { active?: boolean } = {},
): void {
  const active = options.active ?? true;

  useEffect(() => {
    if (!active) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        handler();
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active, handler]);
}
